module.exports = __webpack_public_path__ + "static/img/data_upload_fail.c742acfd.png";